import ProposalSectionPill from "./ProposalSectionPill";

export default ProposalSectionPill;
